<template>
  <div class="introduction-banner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">MoPaaS</span>
        <div class="try-btn-area">
          <router-link to="/contact-us-new">
            <div class="btn-contactUs">联系我们</div>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'IntroductionBanner',
  }
</script>

<style>
  @media(min-width:992px) {
    .introduction-banner {
      width: 100%;
      height: 38.49vw;
      margin-top: 72px;
      overflow-y: hidden;
      background-image: url("../assets/images/introduction-banner.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .introduction-banner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 24.8vw;
    }

    .introduction-banner .banner-overlay1 {
      padding-top: 9.5vw;
      color: #FFFFFF;
      text-align: left;
    }


    .introduction-banner .banner-overlay1 .title {
      height: 100px;
      font-size: 100px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 100px;
    }

    .introduction-banner .btn-contactUs {
      margin-top: 4vw;
      cursor: pointer;
      color: #ffffff;
      width: 168px;
      height: 58px;
      border-radius: 29px;
      background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 400;
    }
  }
  @media(max-width:992px) {
    .introduction-banner {
      width: 100vw;
      height: 38.5vw;
      overflow-y: hidden;
      margin-top: 8vw !important;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-image: url("../assets/images/introduction-banner.png");
    }
    .introduction-banner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 18vw;
    }

    .introduction-banner .banner-overlay1 {
      padding-top: 16vw;
      color: #FFFFFF;
      text-align: left;
    }


    .introduction-banner .banner-overlay1 .title {
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 24px;
    }

    .introduction-banner .banner-overlay1 .try-btn-area {
      color: #FFFFFF;
      width: initial;
      text-align: left;
      display: none;
    }

    .introduction-banner .btn-contactUs {
      width: 24vw;
      margin-top: 4vw;
      cursor: pointer;
      color: #fff;
      border: 1px solid #ffffff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 300;
      padding: 2vw;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/IntroductionBanner.vue